import React from 'react';
import { useTranslation } from 'react-i18next';
import { HtmlTrans, Typography } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material/styles';


import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  a: {
    textDecoration: 'none',
    color: theme.color.link.linkDefault01,
  },
}));

const PsleInstruction = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <ol>
        <li>
          <Typography variant="body1">
            {t('withdrawal->>Coordinator.Instruction.Content2')}
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            {t('withdrawal->>Coordinator.Instruction.EstimatedTimeToComplete')}
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            {t('withdrawal->>Coordinator.Instruction.Content5')}
          </Typography>
        </li>
      </ol>
      <Typography variant="body1">
        <HtmlTrans
          i18nKey="withdrawal->>Coordinator.Instruction.ForMoreInformation"
          values={{
            aClass: classes.a,
          }}
        />
      </Typography>
    </>
  );
};
export default PsleInstruction;
